import { isDefined } from '../api/utils';
import { EnonicDataType, QueueDetailsType, YES_NO } from '../types';

export const SWEDEN_REGEX = /^((((0{2}?)|(\+){1})46)|0)7[\d]{8}$/;

export const appText: Record<string, string> = {
  labelName: 'Namn',
  labelNumber: 'Mobil',
  labelFormHeader: 'Är du kund hos oss idag?',
  labelPersonalNumber: 'Personnummer',
  placeholderPersonalNumber: 'ÅÅÅÅMMDDNNNN',
  formOptionYes: 'Ja',
  formOptionNo: 'Nej',
  callButton: 'Ring upp mig',
  formLabelOptionsCustomer: 'Vad kan vi hjälpa dig med?',
  formYesOptionResponse1: 'Köpa försäkring',
  formYesOptionResponse2: 'Avsluta försäkring',
  formYesOptionResponse3: 'Personförsäkring',
  formOtherResponse: 'Övriga frågor',
  formYesOtherResponsePlaceholder: 'Berätta gärna vad vi kan hjälpa dig med',
  errorTextAll: 'Fältet är obligatoriskt',
  titleInitial: 'Är du rätt försäkrad?',
  descInitial:
    'Vi ringer upp dig och går igenom ditt försäkringsbehov. Fyll i uppgifterna nedan så återkommer vi till dig under våra öppettider, måndag till fredag mellan 8.30 och 17.',
  titleSuccess: 'Tack!',
  descSuccess: 'Vi kommer att ringa upp dig inom kort.',
  errorTextSSN: 'Personnummer är inte korrekt.',
  keyCallMeOk: 'Vi ringer upp dig senast nästa vardag.',
  keyCallMeError: 'Hoppsan, vi verkar ha teknikstrul för tillfället.',
  keyAlreadyRegistered:
    'Vi har redan registrerat din förfrågan om att bli uppringd.',
  keyInvalidPhone: 'Mobilnumret är ogiltigt.',
  keyClosed: 'Du har kontaktat oss utanför våra öppettider.',
  keyDuplicatePhoneNumber:
    'Det finns redan en bokad tid med detta telefonnummer, det går inte att boka en ny tid förrän den bokade tiden har passerat.',
  keyFailureDesc: 'Försök lite senare eller ring kundservice på 0771-326 326',
  keyErroButtonText: 'Försök igen',
  urlErrorImage:
    'https://gjepublictestsa.blob.core.windows.net/claims-sweden/sweden-core/images/ManInRain_detailed.svg'
};

export const customerSelectionOptions = [
  {
    label: appText['formOptionYes'],
    value: YES_NO.yes
  },
  {
    label: appText['formOptionNo'],
    value: YES_NO.no
  }
];

export const daysWithLabelAndValue = {
  MANDAG: { label: 'Måndag', value: 1 },
  TISDAG: { label: 'Tisdag', value: 2 },
  ONSDAG: { label: 'Onsdag', value: 3 },
  TORSDAG: { label: 'Torsdag', value: 4 },
  FREDAG: { label: 'Fredag', value: 5 }
};

export const defaultWorkingHours = '9-15';

const isAvaialble = (value: string) => value.trim().length > 0;

/**
 * Get the queue details based on the environment and the type of call from Enonic data
 * Separate queues for test and prod were created as sometimes the test configs are migrated to
 * prod(and vice versa) and the call is made to the wrong queue when Enonic migration happens.
 * @param configs - Enonic data
 * @param isScheduledCall - If the call is scheduled for later or not
 */
export const getQueueDetails = (
  configs: any,
  isScheduledCall: boolean
): QueueDetailsType => {
  const isProd = window.location.hostname === 'www.gjensidige.se';
  const env = isProd ? 'prod' : 'test';
  const queue = isScheduledCall ? 'later' : 'now';
  const queueKey = `${queue}_queue_${env}`;
  const queueValue: string = configs ? configs[queueKey] : '';
  if (queueValue) {
    const [errand, menuchoice, entrance] = queueValue?.split('|');
    if (
      isAvaialble(errand) &&
      isAvaialble(menuchoice) &&
      isAvaialble(entrance)
    ) {
      return { errand, menuchoice, entrance };
    }
  }
  if (isScheduledCall) {
    return isProd
      ? {
          errand: 'W85',
          menuchoice: 'SE_WCB_BokatSamt',
          entrance: 'Webb'
        }
      : {
          errand: 'T17',
          menuchoice: 'SE_TidsbokatTest',
          entrance: 'WebCallback'
        };
  }

  return isProd
    ? { errand: '670', menuchoice: 'SE_WCB_Ringmig', entrance: 'Webb' }
    : { errand: '375', menuchoice: 'NO_WCB_Privat', entrance: 'Webb' };
};
